import {TemplateAssetType} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import {MovieLayerType} from 'common/src/modules/movie/movie.enums';
import {Box} from 'common/src/modules/movieEditor/movieEditor.types';
import {RemoteComplexTextLine} from 'common/src/modules/complexText/complexText.types';
import {z} from 'zod';
import {shapeSchema, textAnimatorSchema, animatedKeyframeSchema} from './adBuilderAgent.schemas';

export type TemplateAssetsContent = {
  assetType: TemplateAssetType;
  assets: {id: string}[];
  message: string;
  maxSelectable: number;
};

export type AnimatedKeyframeInput = z.infer<typeof animatedKeyframeSchema>;

// Layer details types
export enum LayerDataSection {
  General = 'general',
  Transform = 'transform',
  BoundingBox = 'boundingBox',
  Content = 'content',
  TextAnimators = 'textAnimators',
  All = 'all',
}

export interface LayerGeneralData {
  type: MovieLayerType;
  name: string;
  startTime: number;
  endTime: number;
  time: number;
  isHidden: boolean;
  isLocked: boolean;
  parentLayerId?: string;
  zOrder: number;
}

export interface LayerTransformData {
  transform: {
    position: { x: number; y: number; z: number };
    anchor: { x: number; y: number; z: number };
    scale: { x: number; y: number; z: number };
    rotation: { x?: number; y?: number; z: number };
    opacity: number;
  };
}

export interface LayerBoundingBoxData {
  boundingBoxRelativeToComposition?: Box;
}

export interface LayerContentData {
  text?: {
    lines: RemoteComplexTextLine[];
    boxSize: { w: number; h: number; };
    boxShiftRelativeToLayer: { x: number; y: number; };
  };
  image?: {
    assetId: string | null;
    description: string | null;
    width: number;
    height: number;
    shiftRelativeToLayer: { x: number; y: number };
  };
  video?: {
    assetId: string | null;
    description: string | null;
    width: number;
    height: number;
    shiftRelativeToLayer: { x: number; y: number };
  };
  shape?: z.infer<typeof shapeSchema>;
}

export interface LayerTextAnimatorData {
  animators?: z.infer<typeof textAnimatorSchema>[];
}

export type LayerData = LayerGeneralData & LayerTransformData & LayerBoundingBoxData & LayerContentData & LayerTextAnimatorData;

// Response types for layer details tool
export interface LayerDetailsResult {
  layerId: string;
  data?: Partial<LayerData>; // Only present if successful
  error?: string; // Only present if failed
}

export type LayerDetailsResponse = LayerDetailsResult[];
